import { Grid } from '@mui/material'
import ReportIcon from '@mui/icons-material/Report'
import makeStyles from '@mui/styles/makeStyles'
import { StyledTextOrTranslation } from '.'

const useStyles = makeStyles((theme) => ({
  notaBene: {
    color: theme.variables.colors.notaBene,
    '& .MuiGrid-item > p': {
      wordWrap: 'anywhere'
    },
    marginTop: '32px'
  }
}))

interface NotaBeneProps {
  display?: string
  translationid?: string
}

export const NotaBene = ({ display, translationid }: NotaBeneProps) => {
  const classes = useStyles()

  return (
    <Grid container className={classes.notaBene} columnSpacing={1}>
      <Grid item md="auto" xs="auto">
        <ReportIcon />
      </Grid>
      <Grid item md={true} xs={true}>
        <StyledTextOrTranslation
          text={display}
          translationId={translationid}
          typographyProps={{ variant: 'body1' }}
        />
      </Grid>
    </Grid>
  )
}
